module.exports = __webpack_public_path__ + "static/img/4.7afeb8a3.png";